module.exports = __webpack_public_path__ + "static/media/file.c422dafb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/file.svg
// module id = 1093
// module chunks = 0